import React from 'react'
import PropTypes from 'prop-types'

// material-ui components
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.js'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

// core components
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'

const useStyles = makeStyles(styles)

export default function PeriodSelector ({ periods, onSelect }) {
  const [period, setPeriod] = React.useState('')

  const periodsUpdated = () => {
    let defaultPeriod

    Object.keys(periods).forEach(function (key) {
      if (periods[key].default === true) {
        defaultPeriod = periods[key].value
      }
    })

    if (defaultPeriod) {
      handlePeriod({ target: { value: defaultPeriod } })
    }
  }

  React.useEffect(periodsUpdated, [])

  const handlePeriod = event => {
    setPeriod(event.target.value)
    if (onSelect) {
      onSelect(event.target.value)
    }
  }

  const classes = useStyles()

  return <GridContainer>
    <GridItem xs={12}>
      <FormControl fullWidth className={classes.selectFormControl}>
        <InputLabel shrink htmlFor="period-select" className={classes.selectLabel}>
          Reporting Period
        </InputLabel>
        <Select
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          value={period}
          onChange={handlePeriod}
          displayEmpty
          inputProps={{
            name: 'period',
            id: 'period-select'
          }}
        >
          <MenuItem
            disabled
            classes={{
              root: classes.selectMenuItem
            }}
            value=""
          >
            Choose Report Period
          </MenuItem>
          { periods && Object.keys(periods).map(period => (
            <MenuItem
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected
              }}
              value={periods[period].value}
              key={periods[period].value}
            >
              {periods[period].text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </GridItem>
  </GridContainer>
}

PeriodSelector.propTypes = {
  periods: PropTypes.object,
  defaultPeriod: PropTypes.string,
  onSelect: PropTypes.func
}
